"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXQuoteStructRun = exports.HTMLQuoteStructRun = exports.HTMLQuoteStructRunCSS = void 0;
const react_1 = __importDefault(require("react"));
const html_1 = require("../common/html");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const any_1 = require("./any");
const TextBoxRun_1 = __importDefault(require("../common/docx/TextBoxRun"));
const common_1 = require("../common");
exports.HTMLQuoteStructRunCSS = `
`;
exports.HTMLQuoteStructRun = (0, html_1.wrapHTMLComponent)("HTMLQuoteStructRun", ((props) => {
    const { el, htmlOptions } = props;
    const rawBlocks = (0, any_1.HTMLAnyELsToBlocks)({
        els: el.children,
        indent: 0,
        htmlOptions,
    });
    if (rawBlocks.every(Array.isArray)) {
        const runs = rawBlocks.flat();
        return ((react_1.default.createElement("span", { className: "quote-struct", ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(runs))));
    }
    else {
        const blocks = [];
        for (const rawBlock of rawBlocks) {
            if (Array.isArray(rawBlock)) {
                blocks.push((react_1.default.createElement("div", { className: "quote-struct-runs" }, (0, common_1.withKey)(rawBlock))));
            }
            else {
                blocks.push(rawBlock);
            }
        }
        return (react_1.default.createElement("span", { className: "quote-struct", style: { display: "inline-block" }, ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
    }
}));
exports.DOCXQuoteStructRun = (0, component_1.wrapDOCXComponent)("DOCXQuoteStructRun", ((props) => {
    const { el, docxOptions } = props;
    const rawBlocks = (0, any_1.DOCXAnyELsToBlocks)({
        els: el.children,
        indent: 0,
        docxOptions,
    });
    if (rawBlocks.every(Array.isArray)) {
        const runs = rawBlocks.flat();
        return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(runs)));
    }
    else {
        const blocks = [];
        for (const rawBlock of rawBlocks) {
            if (Array.isArray(rawBlock)) {
                blocks.push((react_1.default.createElement(tags_1.w.p, null, (0, common_1.withKey)(rawBlock))));
            }
            else {
                blocks.push(rawBlock);
            }
        }
        return (react_1.default.createElement(TextBoxRun_1.default, { id: 10000 + el.id, name: `QuoteStruct${el.id}` }, (0, common_1.withKey)(blocks)));
    }
}));
//# sourceMappingURL=quoteStructRun.js.map